import React from 'react';
import Layout from '../../components/Layout';
import UserBanned from './UserBanned';
import messages from '../../locale/jsonMessages';

export default async function action({ intl }) {
  const title = intl?.formatMessage(messages.userBanTabTitle);
  return {
    title,
    component: <Layout><UserBanned title={title} /></Layout>,
    status: 404,
  };
};